import type { FC, PropsWithChildren } from 'react'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

export type LegalTextContentBlockProps = {
	title: string
}

export const LegalTextContentBlock: FC<PropsWithChildren<LegalTextContentBlockProps>> = ({
	title,
	children,
}) => {
	return (
		<ContentBlockWrapper blockTypes={['component', 'cta']} layout="nested">
			{/* Force child paragraph tag formatting */}
			<div className="col-span-full **:text-body-xs!">
				<p className="font-semibold text-blue-shade-70">{title}</p>
				{children}
			</div>
		</ContentBlockWrapper>
	)
}

export default LegalTextContentBlock
